import { Layout } from '@/modules/shared/layouts/layout'

import { useScheduleList } from '../hooks/use-schedule-list.hook'
import ScheduleListInterface from '../interfaces/schedule-list.interface'

export function ScheduleListContainer() {
  const scheduleListHook = useScheduleList()
  return (
    <Layout pageTitle="Agenda" handleGoBack={scheduleListHook.handleGoBack}>
      <ScheduleListInterface {...scheduleListHook} />
    </Layout>
  )
}
